// extracted by mini-css-extract-plugin
export default {"trustedDeviceCard":"TrustedDevice_trustedDeviceCard__hjmfu"};